export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./CardNota.vue?vue&type=template&id=80382bf8&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/CardNota.vue?vue&type=template&id=80382bf8&scoped=true&
// module id = 798
// module chunks = 0